import { CORE_PROJECT, SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants';
import { useIssueKey } from '@atlassian/jira-issue-context-service';
import {
	JSD_TEMPLATE,
	JWM_TEMPLATE,
	DEFAULT_TEMPLATE,
} from '@atlassian/jira-issue-view-layout-templates-constants';
import { useProjectType, useProjectKey } from '@atlassian/jira-project-context-service';

export const useTemplateRendererKey = () => {
	const issueKey = useIssueKey();
	const projectKey = useProjectKey(issueKey);
	const projectType = useProjectType(projectKey);

	switch (projectType) {
		case SERVICE_DESK_PROJECT:
			return JSD_TEMPLATE;
		case CORE_PROJECT:
			return JWM_TEMPLATE;
		default:
			return DEFAULT_TEMPLATE;
	}
};
